import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { easeCustom } from '../presets/animations';

gsap.registerPlugin(ScrollTrigger);

// ─── Parallax ──────────────────────────────────────────────────────────────────

function initParallax() {
  const visuals = document.querySelectorAll('.parallax-img');
  if (!visuals.length) return;

  visuals.forEach((visual) => {
    const img = visual.querySelector('img');
    if (!img) return;

    img.style.willChange = 'transform';

    gsap.fromTo(
      img,
      { yPercent: -12 },
      {
        yPercent: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: visual,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
          invalidateOnRefresh: true,
        },
      }
    );
  });
}

// ─── Highlighting ──────────────────────────────────────────────────────────────────
function initHighlighting() {
  const block = document.querySelector('.o-highlighting__container');
  if (!block) return;

  const mainImg = block.querySelector('.m-compo__main');
  const subImgs = block.querySelectorAll('.m-compo__img:not(.m-compo__main)');

  gsap.set(mainImg, { autoAlpha: 0, yPercent: -20 });
  gsap.set(subImgs, { autoAlpha: 0, yPercent: 20 });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: block,
      start: 'top 90%',
    },
  });

  tl.to(mainImg, { autoAlpha: 1, scale: 1, yPercent: 0, duration: 0.8, ease: 'power2.out' });
  tl.to(
    subImgs,
    { autoAlpha: 1, scale: 1, yPercent: 0, ease: easeCustom, duration: 0.4, stagger: { amount: 0.6 } },
    0.4
  );
}

// ─── Posts list stagger ─────────────────────────────────────────────────────────

export function initPostsListStagger() {
  if (window.innerWidth < 1024) return;

  const items = document.querySelectorAll('.o-posts-list__item:nth-child(3n + 2)');
  if (!items.length) return;

  items.forEach((item) => {
    gsap.to(item, {
      y: 80,
      ease: 'none',
      scrollTrigger: {
        trigger: item,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    });
  });
}

// ─── Init ──────────────────────────────────────────────────────────────────────

export function initAnimations() {
  initParallax();
  initHighlighting();
}
